export const WEBSOCKET_STATUS = {
  IDLE: 'idle',
  CONNECTING: 'connecting',
  OPEN: 'open',
  RECONNECTING: 'reconnecting',
  CLOSED: 'closed',
  ERROR: 'error',
};

export const WEBSOCKET_STATUS_LABEL = {
  [WEBSOCKET_STATUS.IDLE]: 'Idle',
  [WEBSOCKET_STATUS.CONNECTING]: 'Connecting',
  [WEBSOCKET_STATUS.OPEN]: 'Live',
  [WEBSOCKET_STATUS.RECONNECTING]: 'Reconnecting',
  [WEBSOCKET_STATUS.CLOSED]: 'Disconnected',
  [WEBSOCKET_STATUS.ERROR]: 'Connection error',
};

export const WEBSOCKET_RECONNECT = {
  INITIAL_DELAY_MS: 1000,
  MAX_DELAY_MS: 15000,
};

export const EMPLOYEES_MAP_RADIUS_KM = 50;

export const LIVE_LOCATION_MAX_POINTS = 500;
